/** Fired on `window` when a Miro board has been imported as a new Design Canvas; `detail: { canvasId }`. A dependency-free module so UI that only listens (canvas comments, the canvas list) never pulls in the jobs provider. */
export const CANVAS_IMPORTED_EVENT = "miro-canvas-imported";
